import { getRefActivitySectors } from "../../../components/services/httpService";

export async function fetchRefActivitySectors() {
    const res = await getRefActivitySectors();
    if ( !res.ok ) {
        throw new Error( `Failed: ${ res.status }` );
    }
    return await res.json();
}
